import { FormHandles} from '@unform/core';
import { Form } from '@unform/web';
import { Input} from 'components/Shared';
import { useValidation } from 'hooks';
import React, { useCallback, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { FORM_BACK_ACTION } from 'constants/Common';
import { ListClassificationsActions as ListTypes } from 'store/ducks/classifications';
import type { AppDispatch, RootState } from 'store';
import { CreateClassificationActions as CreateActions } from 'store/ducks/classifications';
import { CreateJustificationValidator } from 'validators/Justifications';
import * as S from './styles';

interface Props {
  onCreate?: () => void;
}

export const ClassificationCreationForm: React.FC<Props> = ({ onCreate }) => {
  const dispatch: AppDispatch = useDispatch();
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors, handleApiErrors } = useValidation();

  const { loading: creatingClassification, validationErrors } = useSelector(
    (state: RootState) => state.createClassification
  );

  const fetchListTypes = useCallback((): void => {
    dispatch(ListTypes.request());
  }, []);

  const onSuccess = useCallback((): void => {
    formRef?.current?.reset();
    onCreate && onCreate();
  }, [onCreate]);

  const onSubmit = useCallback(
    async (data: any): Promise<void> => {
      try {
        formRef?.current?.setErrors({});
        const { schema } = new CreateJustificationValidator();

        const validData = await schema.validate(data, {
          abortEarly: false,
        });

        dispatch(CreateActions.request(validData, onSuccess));
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [dispatch, handleFormErrors, onSuccess]
  );

  useEffect(()=>{
    fetchListTypes()
  },[])

  useEffect(() => {
    handleApiErrors(validationErrors, formRef);
  }, [handleApiErrors, validationErrors]);

  useEffect(() => {
    return () => {
      dispatch(CreateActions.reset());
    };
  }, [dispatch]);

  return (
    <S.MainPanel>
      <S.Content>
        <Form ref={formRef} onSubmit={onSubmit}>
            <S.FormRowCreate>
              <Input name="description" label="Classificação" />
            </S.FormRowCreate>
          <S.FormActions>
            <S.LinkButton mood="light" to="/configuracoes/logistica-reversa/classificacoes">
              {FORM_BACK_ACTION}
            </S.LinkButton>
            <S.Button type="submit">
              {creatingClassification ? <S.ActivityIndicator /> : 'Salvar'}
            </S.Button>
          </S.FormActions>
        </Form>
      </S.Content>
    </S.MainPanel>
  );
};
